import React, { useEffect, useRef, useState } from 'react';
import { LoadingSpinner } from '@jove-frontend/uikit';

type Props = {
  isOpen: boolean;
};

export const QuoteWidget = ({ isOpen }: Props) => {
  const iframeRef = useRef<HTMLIFrameElement | null>(null);
  const [isLoading, setLoading] = useState(true);

  useEffect(() => {
    const iframe = iframeRef.current;
    if (!iframe) return undefined;

    const listener = () => console.log('event listener');

    iframe.addEventListener('load', listener);

    return () => {
      iframe.removeEventListener('load', listener);
    };
  });

  return (
    <>
      {isOpen && isLoading && (
        <div className="fixed inset-0 z-50 mx-auto max-w-[414px] bg-white">
          <div className="flex h-full items-center justify-center">
            <LoadingSpinner />
          </div>
        </div>
      )}
      {isOpen && (
        <iframe
          ref={iframeRef}
          id="widgetIframe"
          title="Jove Insurance Quote"
          allowFullScreen={true}
          allow-same-origin="true"
          sandbox="allow-scripts allow-same-origin allow-popups allow-forms"
          className="scrolling-touch margin-0 padding-0 fixed inset-0 z-50 h-full w-full overflow-y-scroll border-0"
          src={`${process.env.NX_QUOTE_ENDPOINT}/?ref=default&theme=default`}
          onLoad={() => setLoading(false)}
        />
      )}
    </>
  );
};
